module.exports = __webpack_public_path__ + "static/media/bristol-myers-squibb.01a03510.png";